import { CLASSES } from "@/scripts/helpers/constants";
import Cookies from "js-cookie";

export default () => {
  const alternativeDrift = $(".alternative-drift-frame"),
        driftChat = $(".drift-frame-controller"),
        driftMessage = $(".drift-frame-message"),
        driftMessageClose = $(".drift-frame-message__popup-close"),
        $body = $("body");

  const checkDrift = () => {
    if (alternativeDrift.length) {
      $body.addClass("drift-custom-body");
      driftChat.addClass("drift-custom-class");

      const driftRefresh = Cookies.get("drift_campaign_refresh");

      if(driftRefresh){
        Cookies.remove('drift_campaign_refresh');
      }
    }
  }

  checkDrift();

  const hiddenDriftMessage = () => {
    driftMessage.addClass(CLASSES.IS_HIDDEN);

    Cookies.set('drift-message-hidden', 'true');
  };

  if (driftChat.length) {
    alternativeDrift.addClass(CLASSES.IS_VISIBLE);

    const driftMessageHidden = Cookies.get("drift-message-hidden");

    if(!driftMessageHidden){
      driftMessage.addClass(CLASSES.IS_VISIBLE);
    }
    
    driftMessageClose.click(function(e) {
      hiddenDriftMessage();
    });

    setTimeout(() => {
      hiddenDriftMessage();
    }, 240000);
    
  }
}
